const autoNgTemplateLoaderTemplate1 = require('./custom-template-selector.html');

import angular from 'angular';
import controller from './custom-template-selector.controller.js';

export const customTemplateSelector = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    newTemplatePath: '@',
    stackType: '<',
    isLoadFailed: '<',

    value: '<',
    onChange: '<',
  },
};

angular.module('portainer.app').component('customTemplateSelector', customTemplateSelector);
